var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("template-card-v2", {
    attrs: {
      "one-log": _vm.oneLog,
      linkedtype: _vm.linkedtype,
      linkedid: _vm.linkedid,
      "has-history": false
    },
    scopedSlots: _vm._u([
      {
        key: "label",
        fn: function() {
          return [_vm._v(_vm._s(_vm.oneLog.title))]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("div", {
              staticClass: "pre-line",
              domProps: { innerHTML: _vm._s(_vm.oneLog.content) }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }